import { render, staticRenderFns } from "./CardBoard.vue?vue&type=template&id=28305b24&scoped=true&"
import script from "./CardBoard.vue?vue&type=script&lang=js&"
export * from "./CardBoard.vue?vue&type=script&lang=js&"
import style0 from "./CardBoard.vue?vue&type=style&index=0&id=28305b24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28305b24",
  null
  
)

export default component.exports